import React, { useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { requestProducts } from 'services/actions/adminActions';

import withViewSize from 'HOC/withViewSize/withViewSize';
import { selectOrderedCategories } from 'selectors/adminSelectors';
import { Toast } from 'shared-components/BaseToast/Toast';
import CampaignForm from './CampaignForm/CampaignForm';
import CampaignManagement from './CampaignManagement/CampaignManagement';

import './CampaignPage.css';

const CampaignPage = ({
  campaigns,
  products,
  fetchingProducts,
  viewSize,
  getProducts,
  categories,
  flags,
}) => {
  const { disableAdminEdit } = flags;
  const [createCampaignOpen, setCreateCampaignOpen] = useState(false);
  return (
    <>
      <div className={viewSize}>
        <div className="campaign-page page-row">
          {createCampaignOpen === false && (
            <CampaignManagement
              campaigns={campaigns}
              products={products}
              getProducts={getProducts}
              fetchingProducts={fetchingProducts}
              categories={categories}
              setCreateCampaignOpen={setCreateCampaignOpen}
              disableAdminEdit={disableAdminEdit}
            />
          )}
          {createCampaignOpen && (
            <CampaignForm
              formType="create"
              onClose={() => setCreateCampaignOpen(false)}
            />
          )}
        </div>
      </div>
      <Toast />
    </>
  );
};

const mapStateToProps = (state) => ({
  campaigns: state.adminState.campaigns,
  products: state.adminState.products,
  categories: selectOrderedCategories(state),
  fetchingProducts: state.adminState.fetchingProducts,
  viewSize: state.viewState.viewSize,
});

const mapDispatchToProps = {
  getProducts: requestProducts,
};

export default compose(
  withViewSize,
  withLDConsumer(),
  connect(mapStateToProps, mapDispatchToProps)
)(CampaignPage);
